<template>
    <span>{{ getStatusString() }}</span> 
</template>

<script>
    export default {
        props: ['status'],
        data() {
            return {
            };
        },
        mounted() {

        },
        methods: {
            getStatusString(){
                
                var statuses = {
                    'P' : 'Pending',
                    'S' : 'Sent',
                    'C' : 'Cancelled'
                };
            
                if(!this.status.notification){
                    return 'No Notification';
                }
                else if(statuses[this.status.notification.send_status]){
                    return statuses[this.status.notification.send_status];
                }
                else{
                    return this.status.notification.send_status;
                }
                
            }
        }
    }
</script>
